'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _modifyUpdatingValue3 = require('./modifyUpdatingValue');

var _modifyUpdatingValue4 = _interopRequireDefault(_modifyUpdatingValue3);

var _setWrappedDisplayName = require('./setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 使用 branch 處理，在 modifier 不存在時還是呼叫 modifyUpdatingValue
// 可能比較有效率
var enhancer = function enhancer(updaterName, input) {
  if (typeof input === 'string') {
    return (0, _branch2.default)(function (_ref) {
      var modifier = _ref[input];
      return !!modifier;
    }, (0, _withHandlers2.default)((0, _modifyUpdatingValue4.default)(_defineProperty({}, updaterName, function (_ref2) {
      var modifier = _ref2[input];
      return modifier;
    }))));
  }

  return (0, _withHandlers2.default)((0, _modifyUpdatingValue4.default)(_defineProperty({}, updaterName, input)));
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'interceptUpdater', true);


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/interceptUpdater.js
// module id = 1697
// module chunks = 0